import { Component } from '@angular/core';
import { TeamCardComponent } from './team-card/team-card.component';
import { NgForOf, NgIf } from '@angular/common';
import { TeamService } from './team.service';
import { MatPaginatorModule } from '@angular/material/paginator';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { SharedServiceService } from '../services/shared-service.service';

@Component({
  selector: 'app-team-listing',
  standalone: true,
  imports: [TeamCardComponent, NgIf, NgForOf, MatPaginatorModule, FormsModule],
  templateUrl: './team-listing.component.html',
  styleUrl: './team-listing.component.css'
})
export class TeamListingComponent {
  totalRecords: number;
  teamList: any = [];
  teamDetails: any = [];
  page = 1;
  pageNumber: any;
  searchText: string = '';
  isAdmin: boolean;
  isLoading: boolean = true;
  // pageSize=25;
  constructor(private teamService: TeamService, private route: Router, private SharedService: SharedServiceService) {
    var role = this.SharedService.getloggedUserRole();
    if (role == 'Administrator') {
      this.isAdmin = true;
    }
    else if (role != 'Administrator') {
      this.isAdmin = false;
    }
  }
  ngOnInit(): void {
    this.getTeams(1);
  }

  getNextPage(id: any) {
    // console.log(id);
    let pageNumber = id.pageIndex + 1;
    this.getTeams(pageNumber);

  }
  addNewTeam() {
    this.route.navigate(['/team-create']);
  }
  getTeams(page: any) {
    this.isLoading = true;
    this.teamService.getAllCohort(page, this.searchText).subscribe(response => {
      this.teamDetails = response;
      this.totalRecords = this.teamDetails['totalCount'];
      this.teamList = this.teamDetails['result'];
      this.isLoading = false;
    });

  }
  filterData(data: any) {   
    this.searchText = data.target.value;
  }
  searchTeam() {
    this.getTeams(1);
  }

}
